/**
 * Component: Vimeo
 * Display Vimeo content in an iFrame and accepts autoplay, mute, control & responsive options
*/

import log from 'salvo-lite/log'
import Player from '@vimeo/player'
import cssClasses from '../helpers/cssClasses'

class Vimeo {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._playing = false
        this._iframe = null
        this._data = {
            ...JSON.parse(this._elem.getAttribute('data-vimeo') || '{}')
        }

        this._selectors = {

        }

        this._nodeSelectors = {
            placeholder: document.querySelector(`[data-video-placeholder="${this._data.video_id}"]`),
            play: document.querySelector(`[data-video-play="${this._data.video_id}"]`)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const options = {
            id: this._data.video_id
        }

        this._video = new Player(this._elem, options)

        this._setListeners()
    }

    /**
     * Set listener on play button
     */
    _setListeners () {
        if (this._nodeSelectors.play) {
            this._nodeSelectors.play.addEventListener('click', () => this._play())
        }
    }

    /**
     * Hide the play button on play
     */
    _play () {
        this._video.play().then(() => {
            this._nodeSelectors.placeholder.classList.add(cssClasses.hidden)
            this._nodeSelectors.play.classList.add(cssClasses.hidden)
            this._playing = true
        })
    }
}

export default Vimeo



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Vimeo.js